
<app-header [logged]="false"  ></app-header>

<div class='container' >
<!-- main app container -->
<div class="row mt-5" >
    <div class="col-6 pt-5" >
        <img class="img-fluid" src="assets/blog_register.png">
    </div>
    <div class="col-6" >
        <div class="card m-3">
            <div class="card-body">
                <h1>Join With Us !!</h1>
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                    <div class="form-row">
          
                        <div class="form-group col">
                            <label>First Name</label>
                            <input type="text" formControlName="first_name" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" />
                            <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback">
                                <div *ngIf="f.first_name.errors.required">First Name is required</div>
                            </div>
                        </div>
                        <div class="form-group col">
                            <label>Last Name</label>
                            <input type="text" formControlName="last_name" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" />
                            <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback">
                                <div *ngIf="f.last_name.errors.required">Last Name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Email</label>
                        <input type="email" formControlName="email" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                            <div *ngIf="f.email.errors.required">Email is required</div>
                            <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
                        </div>
                    </div>
                    <div class="form-group">
                      <label>Blog profile</label>
                      <input type="text" formControlName="profile_url" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.profile_url.errors }" />
          
                  </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <label>Password</label>
                            <input type="password" formControlName="password" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">Password is required</div>
                                <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
                            </div>
                        </div>
                        <div class="form-group col">
                            <label>Confirm Password</label>
                            <input type="password" formControlName="confirmPassword" class="form-control mt-2 mb-2" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                            <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                                <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group form-check">
                        <input type="checkbox" formControlName="acceptTerms" id="acceptTerms" class="form-check-input" [ngClass]="{ 'is-invalid': submitted && f.acceptTerms.errors }" />
                        <label for="acceptTerms" class="form-check-label">Accept Terms & Conditions</label>
                        <div *ngIf="submitted && f.acceptTerms.errors" class="invalid-feedback">Accept Ts & Cs is required</div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary mr-1">Register</button>
                        <button class="btn btn-secondary" type="reset" (click)="onReset()">Cancel</button>
                    </div>
                </form>
            </div>
          </div>
    </div>
</div>



</div>

<div  style="margin-top: 120px;">
  <app-footer  ></app-footer>
</div>
